export default {
  name: "delete-bank-card",
  components: {},
  props: {
    bankData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      deleteCardModal: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    deleteCardConfirmation() {
      this.$emit("confirmDeleteBankCard", false, true);
    }
  }
};
